"use strict";

var _regeneratorRuntime = require("/app/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;

var _toConsumableArray = require("/app/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass.js").default;

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var Events, Group, IORedisConnection, RedisConnection, Scripts, parser;
parser = require("./parser");
Events = require("./Events");
RedisConnection = require("./RedisConnection");
IORedisConnection = require("./IORedisConnection");
Scripts = require("./Scripts");

Group = function () {
  var Group = /*#__PURE__*/function () {
    function Group() {
      var limiterOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, Group);

      this.deleteKey = this.deleteKey.bind(this);
      this.limiterOptions = limiterOptions;
      parser.load(this.limiterOptions, this.defaults, this);
      this.Events = new Events(this);
      this.instances = {};
      this.Bottleneck = require("./Bottleneck");

      this._startAutoCleanup();

      this.sharedConnection = this.connection != null;

      if (this.connection == null) {
        if (this.limiterOptions.datastore === "redis") {
          this.connection = new RedisConnection(Object.assign({}, this.limiterOptions, {
            Events: this.Events
          }));
        } else if (this.limiterOptions.datastore === "ioredis") {
          this.connection = new IORedisConnection(Object.assign({}, this.limiterOptions, {
            Events: this.Events
          }));
        }
      }
    }

    _createClass(Group, [{
      key: "key",
      value: function key() {
        var _this4 = this;

        var _key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

        var ref;
        return (ref = this.instances[_key]) != null ? ref : function () {
          var limiter;
          limiter = _this4.instances[_key] = new _this4.Bottleneck(Object.assign(_this4.limiterOptions, {
            id: "".concat(_this4.id, "-").concat(_key),
            timeout: _this4.timeout,
            connection: _this4.connection
          }));

          _this4.Events.trigger("created", limiter, _key);

          return limiter;
        }();
      }
    }, {
      key: "deleteKey",
      value: function deleteKey() {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var deleted, instance;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  instance = _this.instances[key];

                  if (!_this.connection) {
                    _context.next = 5;
                    break;
                  }

                  _context.next = 4;
                  return _this.connection.__runCommand__(['del'].concat(_toConsumableArray(Scripts.allKeys("".concat(_this.id, "-").concat(key)))));

                case 4:
                  deleted = _context.sent;

                case 5:
                  if (!(instance != null)) {
                    _context.next = 9;
                    break;
                  }

                  delete _this.instances[key];
                  _context.next = 9;
                  return instance.disconnect();

                case 9:
                  return _context.abrupt("return", instance != null || deleted > 0);

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      }
    }, {
      key: "limiters",
      value: function limiters() {
        var k, ref, results, v;
        ref = this.instances;
        results = [];

        for (k in ref) {
          v = ref[k];
          results.push({
            key: k,
            limiter: v
          });
        }

        return results;
      }
    }, {
      key: "keys",
      value: function keys() {
        return Object.keys(this.instances);
      }
    }, {
      key: "clusterKeys",
      value: function clusterKeys() {
        var _this2 = this;

        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var cursor, end, found, i, k, keys, len, next, start, _ref, _ref2;

          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(_this2.connection == null)) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt("return", _this2.Promise.resolve(_this2.keys()));

                case 2:
                  keys = [];
                  cursor = null;
                  start = "b_".concat(_this2.id, "-").length;
                  end = "_settings".length;

                case 6:
                  if (!(cursor !== 0)) {
                    _context2.next = 17;
                    break;
                  }

                  _context2.next = 9;
                  return _this2.connection.__runCommand__(["scan", cursor != null ? cursor : 0, "match", "b_".concat(_this2.id, "-*_settings"), "count", 10000]);

                case 9:
                  _ref = _context2.sent;
                  _ref2 = _slicedToArray(_ref, 2);
                  next = _ref2[0];
                  found = _ref2[1];
                  cursor = ~~next;

                  for (i = 0, len = found.length; i < len; i++) {
                    k = found[i];
                    keys.push(k.slice(start, -end));
                  }

                  _context2.next = 6;
                  break;

                case 17:
                  return _context2.abrupt("return", keys);

                case 18:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      }
    }, {
      key: "_startAutoCleanup",
      value: function _startAutoCleanup() {
        var _this3 = this;

        var base;
        clearInterval(this.interval);
        return typeof (base = this.interval = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          var e, k, ref, results, time, v;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  time = Date.now();
                  ref = _this3.instances;
                  results = [];
                  _context3.t0 = _regeneratorRuntime().keys(ref);

                case 4:
                  if ((_context3.t1 = _context3.t0()).done) {
                    _context3.next = 23;
                    break;
                  }

                  k = _context3.t1.value;
                  v = ref[k];
                  _context3.prev = 7;
                  _context3.next = 10;
                  return v._store.__groupCheck__(time);

                case 10:
                  if (!_context3.sent) {
                    _context3.next = 14;
                    break;
                  }

                  results.push(_this3.deleteKey(k));
                  _context3.next = 15;
                  break;

                case 14:
                  results.push(void 0);

                case 15:
                  _context3.next = 21;
                  break;

                case 17:
                  _context3.prev = 17;
                  _context3.t2 = _context3["catch"](7);
                  e = _context3.t2;
                  results.push(v.Events.trigger("error", e));

                case 21:
                  _context3.next = 4;
                  break;

                case 23:
                  return _context3.abrupt("return", results);

                case 24:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[7, 17]]);
        })), this.timeout / 2)).unref === "function" ? base.unref() : void 0;
      }
    }, {
      key: "updateSettings",
      value: function updateSettings() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        parser.overwrite(options, this.defaults, this);
        parser.overwrite(options, options, this.limiterOptions);

        if (options.timeout != null) {
          return this._startAutoCleanup();
        }
      }
    }, {
      key: "disconnect",
      value: function disconnect() {
        var flush = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var ref;

        if (!this.sharedConnection) {
          return (ref = this.connection) != null ? ref.disconnect(flush) : void 0;
        }
      }
    }]);

    return Group;
  }();

  ;
  Group.prototype.defaults = {
    timeout: 1000 * 60 * 5,
    connection: null,
    Promise: Promise,
    id: "group-key"
  };
  return Group;
}.call(void 0);

module.exports = Group;